<template>
  <div
    class="linked-solic-container"
    :style="{ borderLeftColor: !linkedSolicitationData.is_child ? '#9A62FD1A' : '#FF821A1A' }"
  >
    <div
      class="d-flex items-center"
      style="gap: 10px;"
    >
      <div class="linked-container-icon">
        <v-icon
          color="#E7E3FC"
          size="22"
        >
          {{ icons.mdiLinkVariant }}
        </v-icon>
      </div>
      <div>
        <div
          class="d-flex flex-column"
          style="gap: 4px;"
        >
          <div
            class="d-flex items-center"
            style="gap: 11px;"
          >
            <span style="color: #E7E3FC; font-weight: 600; font-size: 14px;">SLT: {{ linkedSolicitationData.code + " " }} </span>
            <div
              v-if="!linkedSolicitationData.is_child"
              class="badge-container"
            >
              <div
                class="badge"
                style="background-color: #9A62FD1A; color: #9A62FD; padding: 3px 10px; border-radius: 50px; font-weight: 600; font-size: 11px;"
              >
                <span>Pai</span>
              </div>
            </div>
            <span style="color: #7B7792; font-size: 13px; font-weight: 500;">
              N° passageiros: <strong style="color: #E7E3FC; font-size: 14px; font-weight: 600;">{{ linkedSolicitationData.passengers_count }}</strong>
            </span>
          </div>
          <span style="color: #7B7792; font-size: 13px; font-weight: 500;">Destino: <strong style="color: #E7E3FC; font-size: 14px; font-weight: 600;">{{ linkedSolicitationData.address && linkedSolicitationData.address.local_name }}</strong></span>
        </div>
      </div>
    </div>
    <v-tooltip
      v-if="linkedSolicitationData.is_child"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#E7E3FC"
          icon
          :disabled="isUnlinkingSolicitation || isEditMode"
          v-bind="attrs"
          @click="handleUnlinkSolicitation"
          v-on="on"
        >
          <v-icon v-if="!isUnlinkingSolicitation">
            {{ icons.mdiLinkVariantOff }}
          </v-icon>
          <v-progress-circular
            v-else
            indeterminate
            color="white"
            size="20"
            width="2"
            class="ma-0 pa-0"
          ></v-progress-circular>
        </v-btn>
      </template>
      <span>Remover vínculo</span>
    </v-tooltip>
  </div>
</template>

<script>
import axiosIns from '@/plugins/axios'
import { mdiLinkVariant, mdiLinkVariantOff } from '@mdi/js'

export default {
  name: 'LinkedSolicitationCard',
  props: {
    linkedSolicitationData: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: { mdiLinkVariant, mdiLinkVariantOff },
      isUnlinkingSolicitation: false,
    }
  },
  methods: {
    async handleUnlinkSolicitation() {
      const result = await this.$swal({
        title: 'Aviso!',
        html: 'Tem certeza que deseja <b>desvincular</b> esta solicitação?<br>Ao clicar em <b>sim</b>, a solicitação voltará ao status de <b>Novas solicitações</b>.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'SIM',
        cancelButtonText: 'NÃO',
        reverseButtons: true,
        cancelButtonColor: '#FF4C51',
        confirmButtonColor: '#56CA00',
        width: '630px',
      })

      if (!result.isConfirmed) return

      try {
        this.isUnlinkingSolicitation = true
        await axiosIns.patch(`/api/v1/solicitations/transport_solicitation_trip/unlink_solicitation/${this.linkedSolicitationData.id}/`)
        this.$emit('solicitationUnlinked', this.linkedSolicitationData.id)
        this.$swal({
          icon: 'success',
          title: 'Solicitação desvinculada com sucesso!',
        })
      } catch (error) {
        console.error('Error unlinking solicitation:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro ao desvincular solicitação.',
          text: error,
        })
      } finally {
        this.isUnlinkingSolicitation = false
      }
    },
  },
}
</script>

<style scoped>
  .linked-solic-container {
    border-left: 10px solid #FF821A1A;
    border-radius: 10px;
    background: #3B355A;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .linked-container-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #E7E3FC1A;
  }
</style>
